export default "__VITE_ASSET__BxfBCQ1i__"